import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 72253002-9545-40A4-95A4-49401269B553
 * name spellcheck
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spellcheck.svg
 * tags
 */
export const SpellcheckIcon = createSvgIcon(<><path d="M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13M6.43,11L8.5,5.5L10.57,11M12.45,16H14.54L9.43,3H7.57L2.46,16H4.55L5.67,13H11.31L12.45,16Z" /></>, 'SpellcheckIcon');
export default SpellcheckIcon